import { useGetDiscountByCode } from "@/services/discount/hooks/useGetDiscountByCode";
import {
  Button,
  CloseButton,
  Group,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconSearch } from "@tabler/icons-react";
import DiscountDetails from "../discountDetails/discountDetails";
import { ISearch } from "./type";

export function DiscountSearchBox() {
  const form = useForm<ISearch>({
    initialValues: {
      search: "",
    },
    validate: {},
  });
  const code = form?.values.search;

  const { refetch, data, isFetching } = useGetDiscountByCode(code);

  const submit = () => {
    refetch();
  };

  return (
    <Stack flex={1} h="100%">
      <Stack w="100%" h="100%" flex={1} gap="0">
        <form id="search" name="search" onSubmit={form.onSubmit(submit)}>
          <TextInput
            size="md"
            w="100%"
            label="جستجو با کد تخفیف"
            description="کد تخفیف خود را وارد کنید"
            leftSection={
              <CloseButton
                aria-label="Clear input"
                onClick={() => form.setFieldValue("search", "")}
                style={{ display: form?.values?.search ? undefined : "none" }}
              />
            }
            styles={{
              input: {
                fontFamily: "Arial",
                textAlign: "left",
                placeholder: {
                  fontFamily: "IRANSans",
                },
              },
            }}
            {...form.getInputProps("search")}
          />
        </form>

        {data && <DiscountDetails discount={data || {}} />}
      </Stack>
      <Stack py="md">
        <Button
          type="submit"
          form="search"
          loading={isFetching}
          disabled={!code}
          size="md"
        >
          <Group gap="xs">
            <IconSearch />
            <Text> بررسی </Text>
          </Group>
        </Button>
      </Stack>
    </Stack>
  );
}
